// extracted by mini-css-extract-plugin
module.exports =  {"pageErrorWrap":"pageErrorWrap__fh9VM","contentImg":"contentImg__UeJ9n","contentTitle":"contentTitle__hRtAL","contentSubTitle":"contentSubTitle__OaDP7"};